/* istanbul ignore file -- @preserve */

import { ApolloLink, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';

import { initializePendoLink } from 'setup/Pendo';
import { bugsnagBreadcrumbLink, registerBugsnagUserLink } from 'setup/Bugsnag';

// import queryLoggingLink from './queryLoggingLink';
import buildHttpLink from './httpLink';
import buildCableLink from './cableLink';
import invitationAuthLink from './invitationAuthLink';
import sentinelTeamLink from './sentinelTeamLink';
import buildErrorLink from './errorLink';
import mutationsObserverLink from './mutationsObserverLink';

function isSubscription({ query }) {
  const definition = getMainDefinition(query);
  return (
    definition.kind === 'OperationDefinition' &&
    definition.operation === 'subscription'
  );
}

export default function buildApolloLink(config) {
  return ApolloLink.from([
    // queryLoggingLink, // <-- add this to get console logging of query lifecycle
    bugsnagBreadcrumbLink,
    registerBugsnagUserLink,
    initializePendoLink,
    buildErrorLink(config),
    mutationsObserverLink,
    invitationAuthLink,
    sentinelTeamLink,
    split(isSubscription, buildCableLink(), buildHttpLink()),
  ]);
}
